
import Vue, { VueConstructor } from "vue"
import CompanyAutocompleteMixin from "@/mixins/CompanyAutocompleteMixin.vue"
import { Company } from "@/types/Company"

export default (
  Vue as VueConstructor<Vue & InstanceType<typeof CompanyAutocompleteMixin>>).extend({
  name: "CompanyAutocomplete",
  mixins: [
    CompanyAutocompleteMixin
  ],
  components: {
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    emitClientId: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    selectedCompany: null as Company | null,
    companies: [] as Company[]
  }),
  computed: {
    computedLabel(): string {
      return this.label || this.$vuetify.lang.t('$vuetify.mastercompany')
    }
  },
  mounted() {
    (this as any).getCompanies()
  },
  watch: {
    selectedCompany(newVal: Company | null) {
      const value = this.emitClientId ? newVal?.client_id : newVal?.id
      this.$emit('companySelected', value ?? null)
    }
  }
})
